import { useMemo } from 'react';
import dayjs from 'dayjs';

const useDateRangePicker = () => {
  const presets = useMemo(() => {
    return [
      { label: 'Hôm nay', value: [dayjs().add(0, 'd').startOf('D'), dayjs().add(0, 'd').endOf('D')] },
      { label: 'Hôm qua', value: [dayjs().add(-1, 'd').startOf('D'), dayjs().add(-1, 'd').endOf('D')] },
      { label: '7 ngày qua', value: [dayjs().add(-7, 'd').startOf('D'), dayjs().add(0, 'd').endOf('D')] },
      { label: '30 ngày qua', value: [dayjs().add(-30, 'd').startOf('D'), dayjs().add(0, 'd').endOf('D')] },
      { label: 'Tháng này', value: [dayjs().startOf('M').startOf('D'), dayjs().endOf('D')] },
      { label: 'Tháng trước', value: [dayjs().add(-1, 'month').startOf('M').startOf('D'), dayjs().add(-1, 'month').endOf('M').endOf('D')] },
    ];
  }, []);

  return {
    presets,
  };
};

export default useDateRangePicker;
